<template>
  <div class="w-full overflow-auto bg-n-surface-1 px-4 sm:px-6 lg:px-8">
    <div class="mx-auto w-full max-w-[90rem] pb-12">
      <router-view />
    </div>
  </div>
</template>
